import { Descriptions } from "antd";
import moment from "moment";
import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { IEvent } from "../../../models/events.model";
import Button from "../../Button";

interface IProps {
  data: IEvent|undefined;
}

const EducationReader1: FC<IProps> = ({ data }) => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();

  const getCampusInfo = () => {
    if (!data) return '';
    if (data.allCampusYn === 'Y') return t('common.text.all');

    let str = '';
    data.campuses.forEach(item => {
      str += `${item.campusKorName}, `;
    });
    return str.slice(0, -2);
  }

  return (
    <div className='comm-table__area rowType'>
      <Descriptions
        bordered
        column={4}
        size="small"
        labelStyle={{ width: '12.5%' }}
        contentStyle={{ width: '12.5%' }}
      >
        <Descriptions.Item label={t('event.education.column10')} span={4}>
          {data?.eventName}
        </Descriptions.Item>
        <Descriptions.Item label={t('common.menu.campus')} span={4}>
          {getCampusInfo()}
        </Descriptions.Item>
        <Descriptions.Item label={t('event.education.column12')}>
          {moment(data?.eventDate).format('YYYY.MM.DD')} {data?.eventTime}
        </Descriptions.Item>
        <Descriptions.Item label={t('event.education.column7')}>
          {moment(data?.registSrtDate).format('YYYY.MM.DD')}
        </Descriptions.Item>
        <Descriptions.Item label={t('event.education.column8')}>
          {moment(data?.registEndDate).format('YYYY.MM.DD')}
        </Descriptions.Item>
        <Descriptions.Item label={t('event.education.column3')}>
          {data?.openYn === 'Y' ? t('common.option.yes') : t('common.option.no')}
        </Descriptions.Item>
        <Descriptions.Item label={t('event.education.column19')}>
          {t('event.education.text4')}{data?.require} {t('event.education.text5')}
        </Descriptions.Item>
        <Descriptions.Item label={t('event.education.column20')}>
          {t('event.education.text4')}{data?.attend} {t('event.education.text5')}
        </Descriptions.Item>
        <Descriptions.Item label={t('event.education.column5')}>
          {data?.quota ? `${t('event.education.text4')}${data?.quota} ${t('event.education.text5')}` : t('event.education.text2')}
        </Descriptions.Item>
        <Descriptions.Item label={t('event.education.column21')}>
          {Number(data?.paymentAmount)?.toLocaleString()} {t('event.education.text3')}
        </Descriptions.Item>
        <Descriptions.Item label={t('event.education.column15')} span={4}>
          <div dangerouslySetInnerHTML={{ __html: data?.content || '' }} />
        </Descriptions.Item>
        <Descriptions.Item label={t('event.education.column17')} span={4}>
          {
            data?.eventFiles
              ? data?.eventFiles.map(item => (
                <a
                  className="download-link mr-2"
                  href={item.fileLocation}
                  download={item.originalName}
                >
                  {item.originalName}
                </a>
              ))
              : '-'
          }
        </Descriptions.Item>
      </Descriptions>

      <div className="comm-bx__between">  
        <div className="comm-btn__area">
          <Button
            onClick={() => history.push(`/event/education${location.search}`)}
            className="btn-basic gray-line"
            text={t('common.button.list')}
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            onClick={() => history.push(`/event/education/${data?.eventNo}/edit${location.search}`)}
            className="btn-basic pink-line"
            text={t('common.button.edit')}
            writeAuthYn={writeAuthYn}
          />
          <Button
            onClick={() => history.push(`/event/education/${data?.eventNo}/register`)}
            className="btn-basic pink-line"
            text={t('event.education.button5')}
          />
        </div>
      </div>
    </div>
  );
}

export default EducationReader1;
